/**
 * Single source of truth for the three DLPlatforms products.
 *
 * Consumed by the landing page (TractionBar, ProductPortfolio) and the
 * /projects page (ProjectWrap, ProjectCardFilter). Update numbers here only.
 *
 * image: path relative to /public, resolved with PUBLIC_URL at render time.
 * users: raw count, used for the animated counters and the portfolio total.
 */
const projects = [
  {
    id: 1,
    slug: "dlsurf",
    name: "DLSurf",
    category: "Creator Monetization",
    tagline: "600,000+ Creators & Counting",
    users: 600000,
    usersLabel: "600,000+",
    usersNoun: "creators",
    image: "img/project/dlsurf.jpg",
    link: "https://dlsurf.com/",
    summary:
      "One resource hub where creators publish files, blogs, links and bundles, then earn from them through ads or direct pricing.",
    description:
      "Our creator monetization platform. DLSurf gives creators one resource hub for files, blogs, links and bundles. Publish once, then earn through ads or direct pricing. Trusted by 600,000+ creators, with communities, real-time analytics, AI publishing tools and direct payouts from as little as $1.",
  },
  {
    id: 2,
    slug: "fithisaab",
    name: "FitHisaab",
    category: "AI Health & Fitness",
    tagline: "10,000+ Members Training",
    users: 10000,
    usersLabel: "10,000+",
    usersNoun: "members",
    image: "img/project/fithisaab.svg",
    link: "https://fithisaab.com/",
    summary:
      "An AI workout and diet tracker for lifters, paired with management software for the gyms they train at.",
    description:
      "A free AI workout and diet tracker. Lifters log sets with automatic rest timers, scan any meal for instant macros, and watch their volume and strength curves compound. Gym owners manage members, attendance, payments and coach-assigned plans from the same platform. Available on iOS, Android and web.",
  },
  {
    id: 3,
    slug: "automyc",
    name: "Automyc",
    category: "AI Workflow Automation",
    tagline: "1,500+ Inboxes Automated",
    users: 1500,
    usersLabel: "1,500+",
    usersNoun: "users",
    image: "img/project/automyc.png",
    link: "https://automyc.com/",
    summary:
      "AI automation for Gmail and WhatsApp, with multi-channel campaigns and a reply agent that answers in your own voice.",
    description:
      "AI-powered automation for Gmail and WhatsApp. Teams connect multiple inboxes and numbers, launch multi-channel campaigns with conditional follow-ups, and let a context-aware reply agent draft responses in their own voice. Official WhatsApp API sending and deliverability controls are built in.",
  },
];

/** Combined reach across the portfolio. Derived, never hardcoded. */
export const totalUsers = projects.reduce((sum, p) => sum + p.users, 0);

export default projects;
